<template>
    <div class="flex flex-col gap-[10px] md:gap-[20px]">
        <TitleBlockStat title="***" info-text="all chart" info-link="/admin"></TitleBlockStat>
        <!-- <pre>{{ props.data }}</pre> -->
        <ChartMain :mentions-over-time="props.data.mentionsOverTime"></ChartMain>
    </div>
</template>

<script setup>
import TitleBlockStat from '@/Components/BrandMonitoring/TitleBlockStat.vue';
import ChartMain from '@/Components/BrandMonitoring/ChartMain.vue';

const props = defineProps({
    data: Object,
    prefixRoute: String
});
</script>